import React from 'react'
const ItemMenu = ({ menu }) => (<div onClick={menu.action}>{menu.text}</div>)
export default ItemMenu
